<template>
  <div class="info-container">

    <div v-if="view === 'portrait'" :key="view">
      <div class="info-wrapper">
        <div class="info-head">
          <transition name="fade" mode="out-in">
            <h3 :key="selectedCountry.ID" v-bind:class="'flag-' + selectedCountry.ID ">{{ selectedCountry.Land }}</h3>
          </transition>
          <p class="icon-eu">Beitrittsjahr: 
            <transition name="fade" mode="out-in">
              <span :key="selectedCountry.ID">{{ getYear() }}</span>
            </transition>
          </p>
          <p class="icon-population">Einwohner 2025: <transition name="fade" mode="out-in"><span :key="selectedCountry.ID">{{ getPopulation() }} Mio.</span></transition></p>
        </div>
        <div class="info-body">
          <ul class="info-list">
            <li v-bind:class="item.cl" v-if="item.value !== '8'" v-for="(item, index) in filter" :key="item.value">
              <div>
                {{ getLabel(item.value, selectedCountry) }}
                <span>{{ getDescription(item.value, selectedCountry) }}</span>
              </div>
              <div class="info-value">
                <transition name="fade" mode="out-in">
                  <span :key="selectedCountry.ID">{{ getValue(item.value, selectedCountry) }} {{item.unit}}</span>
                </transition></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="view === 'comparison'" :key="view">
    <div class="info-wrapper-height">
        <div class="info-wrapper" v-if="curFilter && countries.length > 0 ">
          <div class="info-head filter">
            <div v-bind:class="curFilter.cl">
              <h3>{{ getLabel(curFilter.value, countries[0]) }}</h3>
              <span>{{ getDescription(curFilter.value, countries[0] ) }}</span>
            </div>
          </div>

          <div class="chart-wrapper">
            
          <ul class="chart">
            <li v-for="(item, index) in sortCountries(curFilter.value, countries)" :key="item.ID" v-if="item.Euro === '1'">
              <div class="label">{{ item.Land }}</div>
              <div class="bar-wrapper">
                <div class="bar" v-bind:aniWidth="getBarWidth(item, curFilter)" style="width:0%, margin-left:0">&nbsp;</div>
                <div class="value">{{ getValue(curFilter.value, item) }} {{ curFilter.unit }}</div>  
              </div>
            </li>
            <li>
              <div class="label"></div>
              <div class="bar-wrapper">
                <div class="bar z" v-bind:aniWidth="getBarWidth(null, curFilter)"><div class="zero"></div></div>
              </div>
            </li>
          </ul>

          </div>

        </div>

        <div class="info-wrapper preview" v-else>

          <div class="info-head filter">
            <div v-bind:class="filter[0].cl">
              <h3>{{ getLabel(filter[0].value, all[0]) }}</h3>
              <span>{{ getDescription(filter[0].value, all[0] ) }}</span>
            </div>
          </div>

          <ul class="chart">
            <li v-for="(item, index) in sortCountries(filter[0].value, all)" :key="item.ID" 
              v-if="item.Euro === '1' && index < 4 ">
              <div class="label">{{ item.Land }}</div>
              <div class="bar-wrapper">
                <div class="bar" v-bind:aniWidth="getBarWidth(item, filter[0])" style="width:0%">&nbsp;</div>
                <div class="value">{{ getValue(filter[0].value, item) }} {{ filter[0].unit }}</div>  
              </div>
           <li>
              <div class="label"></div>
              <div class="bar-wrapper">
                <div class="bar" v-bind:aniWidth="getBarWidth(null, curFilter)"><div class="zero"></div></div>
              </div>
            </li>
          </ul>
          
          <div class="info-messages">
              <p v-if="!curFilter">Wählen Sie eine Kennzahl aus.</p>
              <p v-if="countries.length === 0">Wählen Sie die Länder zum Vergleich aus.</p>
          </div>
        </div>

        </div>

    </div>
</div>
</template>


<script>

  let rr = require('window.requestanimationframe')

  export default {
    name: 'info',
    props: ['selectedCountry', 'view', 'filter', 'curFilter', 'countries', 'all', 'columns'],

    mounted : function() 
    {
    },

    methods: {

      getFilter: function(index) {
        return this.selectedCountry[this.columns[1]]
      },

      getYear: function() {
        return this.selectedCountry[this.columns[2]]
      },
      getPopulation: function() {

        let val = this.selectedCountry[this.columns[3]]
        val = val.replace('.', ',')
        return val

      },
      getLabel: function(index, obj) {
        let text = this.columns[index].split(' ')[0]
        return text;
      },
      getDescription: function(index, obj) {
        let text = this.columns[index].split(' ')
        if (text.length > 0 ) {
          text.shift()
          text = text.join(' ')
        }
        return text
      },
      getValue: function(index, obj) {
        let val = (obj[this.columns[index]] === '') ? 'keine Angabe' : obj[this.columns[index]]
        if (index != 4)
          val = val.replace('.', ',')
        return val
      },
      sortCountries: function(filter, countries) {

        // return countries.slice().sort( (a, b) => {
        //     let x = ( parseFloat(a[this.columns[filter]]) ) ? parseFloat(a[this.columns[filter]]) : 0
        //     let y = ( parseFloat(b[this.columns[filter]]) ) ? parseFloat(b[this.columns[filter]]) : 0
        //     return x - y
        // }).reverse();

        return countries.slice().sort( 
          function (a, b) {
          // (a, b) => {
            let x = ( parseFloat(a[this.columns[filter]]) ) ? parseFloat(a[this.columns[filter]]) : 0
            let y = ( parseFloat(b[this.columns[filter]]) ) ? parseFloat(b[this.columns[filter]]) : 0
            return x - y
        }.bind(this)).reverse();

      },
      getBarWidth: function(item, filter) {
        let width = 0,
            margin = 0,
            scale = 70,
            offset = 4,
            zeroX = 0,  
            val = (item) ? item[this.columns[filter.value]] : parseInt(0);

        if ( filter.min >= 0) {
            width = val *  scale / filter.max
        }
        else {

          let full = (filter.min - filter.max) * -1
          zeroX = ( (filter.min *-1) * scale / full ) + offset

          if (val >= 0) {
              width = val *  scale / full
              margin = ( (filter.min *-1) * scale / full ) + offset
          }
          else {
            width = val *  scale / full *-1
            margin =  ( (filter.min *-1) * scale / full ) - width + offset
          }

        }

        let calcValues = width + '%;' + margin + '%;'

        return calcValues
      }
    },

    updated: function() {


      window.requestAnimationFrame(function() {

        let barWrappers = this.$el.querySelectorAll('.bar-wrapper'),
              margin = 0

          for (let i = 0, l = barWrappers.length; i<l; i++)
          {

            let wrapper = barWrappers[i]
            let bar = wrapper.querySelector('.bar')
                // zero = wrapper.querySelector('.zero')

            if (bar) {

              let w = bar.getAttribute('aniWidth').split(';')[0], 
                  m = bar.getAttribute('aniWidth').split(';')[1]

              let z = bar.querySelector('.zero')

              if (!z) {
                bar.style.width = w
                bar.style.marginLeft = m
              }
              else {
                if (this.countries.length === 0 || !this.curFilter) z.style.left = '0%'
                else z.style.left = m;
              } 
            }
        }
      }.bind(this))

      // requestAnimationFrame( 
      // setTimeout(function() {

          // let barWrappers = this.$el.querySelectorAll('.bar-wrapper'),
          //     margin = 0

          // for (let i = 0, l = barWrappers.length; i<l; i++)
          // {
          //   let wrapper = barWrappers[i]
          // // barWrappers.forEach(function(wrapper) {

          //   let bar = wrapper.querySelector('.bar')
          //       // zero = wrapper.querySelector('.zero')

          //   if (bar) {

          //     let w = bar.getAttribute('aniWidth').split(';')[0], 
          //         m = bar.getAttribute('aniWidth').split(';')[1]

          //     let z = bar.querySelector('.zero')

          //     if (!z) {
          //       bar.style.width = w
          //       bar.style.marginLeft = m
          //     }
          //     else {

          //       if (this.countries.length === 0 || !this.curFilter) z.style.left = '0%'
          //       else z.style.left = m;
          //     } 
          //   }

          // }.bind(this), 100)
        // }

      // }.bind(this))
      // )

    },

    watch: {
    },

    data: function() {
      return {
      }
    }
  }
</script>

<style lang="scss" src="./style.scss"></style>



// WEBPACK FOOTER //
// Info.vue?361b50e8